(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    // Shopify's native contact form is a plain server-rendered POST, so
    // after a submission the success message or error summary is already
    // in the page on load — screen readers won't announce static content
    // that just happened to be there, so this moves keyboard focus to it
    // (both carry tabindex="-1" and role="status"/"alert" for exactly
    // this) the same way native form-error handling works elsewhere in
    // this theme. No other behavior is added — no re-implemented
    // validation, no AJAX submission.
    var status = document.querySelector('[data-contact-form-success], [data-contact-form-errors]');
    if (status) status.focus();
  });
})();
